import axios from "axios";

export type AuthResponseDto = {
  accessToken: string;
  refreshToken: string;
  expiresAtUtc: string;
  userObjectId: string;
  email: string;
};

export type RegisterStartResponseDto = {
  requiresEmailVerification: boolean;
  email: string;
  expiresInSeconds: number;
};

export type CheckEmailResponseDto = {
  exists: boolean;
  needsEmailVerification: boolean;
};

const baseURL = process.env.REACT_APP_API_URL;
if (!baseURL) {
  throw new Error("REACT_APP_API_URL is not defined in the .env file");
}

export async function login(email: string, password: string): Promise<AuthResponseDto> {
  const res = await axios.post<AuthResponseDto>(`${baseURL}/Auth/login`, { email, password });
  return res.data;
}

export async function register(payload: { email: string; password: string; firstName: string; lastName: string }): Promise<RegisterStartResponseDto> {
  const res = await axios.post<RegisterStartResponseDto>(`${baseURL}/Auth/register`, payload);
  return res.data;
}

export async function checkEmailExists(email: string): Promise<CheckEmailResponseDto> {
  const res = await axios.get<CheckEmailResponseDto>(`${baseURL}/Auth/check-email`, {
    params: { email: email.trim() },
  });
  return res.data;
}

export async function refreshToken(refreshToken: string): Promise<AuthResponseDto> {
  const res = await axios.post<AuthResponseDto>(`${baseURL}/Auth/refresh-token`, { refreshToken });
  return res.data;
}

export async function socialLogin(payload: {
  provider: "google" | "linkedin" | "apple";
  idToken?: string;
  accessToken?: string;
}): Promise<AuthResponseDto> {
  const res = await axios.post<AuthResponseDto>(`${baseURL}/Auth/social-login`, payload);
  return res.data;
}

export async function verifyEmail(payload: { email: string; code: string }): Promise<AuthResponseDto> {
  const res = await axios.post<AuthResponseDto>(`${baseURL}/Auth/verify-email`, payload);
  return res.data;
}

export async function resendVerificationEmail(email: string): Promise<{ message: string }> {
  const res = await axios.post<{ message: string }>(`${baseURL}/Auth/resend-verification-email`, { email });
  return res.data;
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const res = await axios.post<{ message: string }>(`${baseURL}/Auth/forgot-password`, { email });
  return res.data;
}

export async function resetPassword(payload: { email: string; code: string; newPassword: string }): Promise<{ message: string }> {
  const res = await axios.post<{ message: string }>(`${baseURL}/Auth/reset-password`, payload);
  return res.data;
}

